import React from "react";
import { Paper, Typography, Grid, CircularProgress, Chip, Button, makeStyles, CardActionArea } from "@material-ui/core";
import { Link } from "react-router-dom";
import jMoment from "moment-jalaali";

const useStyles = makeStyles(() => ({
  titleTypo: {
    fontWeight: "bold",
    fontSize: "15px",
  },
  wrapperPaper: {
    marginRight: 10,
    padding: 15,
  },
  wrapperGrid: {
    overflow: "auto",
    maxHeight: 390,
    marginTop: 15,
  },
  progress: {
    color: "#757575",
  },
  itemPaper: {
    // padding: "5px 10px",
    width: "100%",
    // marginRight: 10,
    marginBottom: 10,
    overflow: "hidden",
  },
  cardAction: {
    padding: "8px 10px",
  },
}));

const RecentValuations = (props) => {
  const { loading, recentValuations = [] } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.wrapperPaper}>
      <Typography className={classes.titleTypo}>ارزیابی های اخیر</Typography>

      <Grid container className={classes.wrapperGrid}>
        {loading ? (
          <Grid container alignItems='center' alignContent='center' justifyContent='center'>
            <CircularProgress className={classes.progress} />
          </Grid>
        ) : !(recentValuations.length > 0) ? (
          <Grid container alignItems='center' alignContent='center' justifyContent='center'>
            <Chip variant='outlined' label='ارزیابی برای نمایش وجود ندارد!' style={{ margin: 20 }} />
          </Grid>
        ) : (
          recentValuations.map((val) => (
            <Paper variant='outlined' className={classes.itemPaper}>
              <CardActionArea component={Link} to={"/panel/valuations/view/" + val.id} className={classes.cardAction}>
                <Grid container direction='row'>
                  <Typography style={{ flexGrow: 1 }}>{val.user.first_name + " " + val.user.last_name}</Typography>
                  <Typography
                    style={{
                      color: "#757575",
                      fontSize: "13px",
                      marginLeft: "5px",
                    }}
                  >
                    در:
                  </Typography>
                  <Typography style={{ color: "#757575", fontSize: "13px" }}>
                    {jMoment(val.date).format("jYYYY/jMM/jDD").toString()?.toPersianDigits()}
                  </Typography>
                </Grid>

                <Typography
                  style={{
                    color: "#757575",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  ارزیابی یک {val.from} با نوع سازه {val.structure_type} انجام داده است.
                </Typography>
              </CardActionArea>
            </Paper>
          ))
        )}
      </Grid>
    </Paper>
  );
};
export default RecentValuations;
